const xChar = '×';

const clearXChar = () => {
  const speedControls = Array.from(document.querySelectorAll('[data-plyr="speed"] span'));
  const settingsHolders = Array.from(document.querySelectorAll('[data-plyr="settings"] .plyr__menu__value'));

  const totalValueHolders = [...speedControls, ...settingsHolders];

  totalValueHolders.forEach(holder => {
    const value = holder.innerHTML;
    const isXChar = value.includes(xChar);
    if (isXChar) {
      holder.innerHTML = value.replace(xChar, '');
    }
  });
};

export default clearXChar;
